import PropTypes from "prop-types";
import { useEffect } from "react";

import { useSiteMetadata } from "app/settings";

const CommonLayout = ({ children }) => {
    const site = useSiteMetadata();

    useEffect(() => {
        // eslint-disable-next-line no-console
        console.table(site);
    });

    return children;
};

CommonLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CommonLayout;
